import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccessLicense = () => {
  const { state, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (pathname === "/payment-success-license") {
        navigate("/license");
      } else {
        navigate("/");
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, pathname]);

  return (
    <div className="h-screen flex flex-col justify-center items-center gap-2 p-5">
      <img
        src="/assets/images/success.gif"
        alt="Success"
        className="md:w-[500px]"
      />

      <p className="text-green-500 text-2xl font-semibold">Thank You!</p>

      <p className="text-secondaryLight1 text-lg text-center">
        {state?.message || ""}
      </p>
    </div>
  );
};

export default PaymentSuccessLicense;
